import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'PromptExamples',
  props: {
  userInputting: Boolean
},
  emits: ['onSelectPrompt'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

document.addEventListener('keydown', function (event) {
  const key = Number(event.key);
  if (
    !props.userInputting &&
    event.key != ' ' &&
    !isNaN(key) &&
    key <= store.getExamplePrompts().length
  ) {
    selectPrompt(key - 1);
  }
});

function selectPrompt(index: number) {
  const prompt = store.getExamplePrompts()[index];

  window.setTimeout(() => emit('onSelectPrompt', prompt), 50);
}

const __returned__ = { props, emit, selectPrompt, get store() { return store } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})